module.exports = __webpack_public_path__ + "img/mobile_alan_h.276c3e19.jpg";